"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_3 = require("@emotion/react");
var recoil_1 = require("recoil");
var components_1 = require("@/components");
var styles_1 = require("./styles");
var store_1 = require("./store");
var api = __importStar(require("./api"));
var constants_1 = require("./constants");
var pages_1 = require("./pages");
var RequiredAuth = function (_a) {
    var children = _a.children, isAuth = _a.isAuth, _b = _a.to, to = _b === void 0 ? constants_1.PATH.LOGIN : _b, restProps = __rest(_a, ["children", "isAuth", "to"]);
    if (!isAuth) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, __assign({}, restProps, { to: to }), void 0);
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }, void 0);
};
var MasterOnly = function (_a) {
    var children = _a.children, isMaster = _a.isMaster, _b = _a.to, to = _b === void 0 ? constants_1.PATH.APPLICATION : _b, restProps = __rest(_a, ["children", "isMaster", "to"]);
    if (!isMaster) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, __assign({}, restProps, { to: to }), void 0);
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }, void 0);
};
var App = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var TOKEN = localStorage.getItem(constants_1.ACCESS_TOKEN);
    var isAuthorized = (0, recoil_1.useRecoilValue)(store_1.$isAuthorized) || !!TOKEN;
    var toast = (0, recoil_1.useRecoilValue)(store_1.$toast);
    var generationNumber = (0, recoil_1.useRecoilValue)(store_1.$generationNumber);
    var isMaster = (0, recoil_1.useRecoilValue)(store_1.$isMaster);
    var getTeams = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.getTeams(generationNumber)];
                    case 1:
                        teams = (_a.sent()).data;
                        set(store_1.$teams, teams);
                        return [2 /*return*/];
                }
            });
        }); };
    });
    (0, recoil_1.useRecoilCallback)(function (_a) {
        var snapshot = _a.snapshot, set = _a.set, reset = _a.reset;
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var isAuthorizedSnapshot, _a, me, generations, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isAuthorizedSnapshot = snapshot.getLoadable(store_1.$isAuthorized).contents;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        if (!(!isAuthorizedSnapshot && !!TOKEN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([
                                api.getMyInfo(),
                                api.getGenerations(),
                            ])];
                    case 2:
                        _a = __read.apply(void 0, [_b.sent(), 2]), me = _a[0].data, generations = _a[1].data;
                        set(store_1.$me, { accessToken: TOKEN, adminMember: me });
                        set(store_1.$generations, generations);
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        localStorage.removeItem(constants_1.ACCESS_TOKEN);
                        reset(store_1.$me);
                        navigate(constants_1.PATH.LOGIN);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    })();
    (0, react_2.useEffect)(function () {
        if (!isAuthorized) {
            return;
        }
        getTeams();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthorized, generationNumber]);
    return ((0, jsx_runtime_1.jsx)(react_3.ThemeProvider, __assign({ theme: styles_1.theme }, { children: (0, jsx_runtime_1.jsxs)(react_2.Suspense, __assign({ fallback: null }, { children: [(0, jsx_runtime_1.jsx)(react_3.Global, { styles: styles_1.globalStyles }, void 0), (0, jsx_runtime_1.jsx)(components_1.ModalViewer, {}, void 0), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsxs)(react_router_dom_1.Route, __assign({ path: "/", element: (0, jsx_runtime_1.jsx)(components_1.Layout, {}, void 0) }, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.APPLICATION, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ApplicationList, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.APPLICATION_DETAIL, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ApplicationDetailView, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.EMAIL, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.EmailSendingList, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.APPLICATION_FORM, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ApplicationFormList, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.APPLICATION_FORM_DETAIL, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ApplicationFormDetail, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.APPLICATION_FORM_UPDATE, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.UpdateApplicationForm, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.APPLICATION_FORM_CREATE, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.CreateApplicationForm, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.ACTIVITY_SCORE, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ActivityScoreList, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.ACTIVITY_SCORE_DETAIL, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ActivityScoreDetail, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.SCHEDULE, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ScheduleList, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.SCHEDULE_CREATE, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.CreateSchedule, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.SCHEDULE_DETAIL, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.ScheduleDetail, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.SCHEDULE_UPDATE, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.UpdateSchedule, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.UPDATE_PLATFORM_RECRUIT, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.UpdatePlatformRecruit, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.ADMIN_MEMBERS, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(MasterOnly, __assign({ isMaster: isMaster }, { children: (0, jsx_runtime_1.jsx)(pages_1.AdminMemberList, {}, void 0) }), void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.FAQ, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: isAuthorized }, { children: (0, jsx_runtime_1.jsx)(pages_1.FaqPage, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: TOKEN ? constants_1.PATH.APPLICATION : constants_1.PATH.LOGIN }, void 0) }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.LOGIN, element: (0, jsx_runtime_1.jsx)(RequiredAuth, __assign({ isAuth: !isAuthorized, to: constants_1.PATH.APPLICATION }, { children: (0, jsx_runtime_1.jsx)(pages_1.LoginPage, {}, void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "*", element: (0, jsx_runtime_1.jsx)(pages_1.ErrorPage, { path: constants_1.PATH.NOT_FOUND }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: constants_1.PATH.FORBIDDEN, element: (0, jsx_runtime_1.jsx)(pages_1.ErrorPage, { path: constants_1.PATH.FORBIDDEN }, void 0) }, void 0)] }, void 0), toast && (0, jsx_runtime_1.jsx)(components_1.Toast, {}, void 0)] }), void 0) }), void 0));
};
exports.default = App;
